import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DateRange } from 'react-day-picker';
import { PrimeTimesModeSelector } from './PrimeTimesModeSelector';
import { PrimeTimesTabNavigation } from './PrimeTimesTabNavigation';
import { GeneralDataView } from './GeneralDataView';
import { ResultDataView } from './ResultDataView';
import { PrimeTimeMetric, ConversionMetric } from '../hooks/types/primeTimesTypes';

type PrimeTimesMode = 'general' | 'result';

interface PrimeTimesTabViewProps {
  date?: DateRange;
  videoId: string | null;
  metricsEnhanced?: any;
}

export function PrimeTimesTabView({ date, videoId, metricsEnhanced }: PrimeTimesTabViewProps) {
  // Estado principal: modo (Dados Gerais ou Resultado)
  const [mode, setMode] = useState<PrimeTimesMode>('general'); // default = Dados Gerais
  
  // Métricas separadas para cada modo
  const [generalMetric, setGeneralMetric] = useState<PrimeTimeMetric>('plays');
  const [resultMetric, setResultMetric] = useState<ConversionMetric>('conversions');
  
  const activeMetric = mode === 'general' ? generalMetric : resultMetric;

  return (
    <Card>
      <CardHeader className="pt-8 pb-6 px-6">
        <div className="space-y-4">
          {/* Segmented Control (Dados Gerais | Resultado) */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <PrimeTimesModeSelector 
              mode={mode}
              onModeChange={(newMode) => {
                setMode(newMode);
              }}
            />

            {/* Tabs secundárias (mudam conforme o modo) */}
            <PrimeTimesTabNavigation 
              mode={mode}
              activeMetric={activeMetric}
              onMetricChange={(metric) => {
                if (mode === 'general') {
                  setGeneralMetric(metric as PrimeTimeMetric);
                } else {
                  setResultMetric(metric as ConversionMetric);
                }
              }}
            />
          </div>
        </div>
      </CardHeader>

      <CardContent className="pt-8">
        {mode === 'general' ? (
          <GeneralDataView
            metric={generalMetric}
            date={date}
            videoId={videoId}
            metricsEnhanced={metricsEnhanced}
          />
        ) : (
          <ResultDataView
            metric={resultMetric}
            date={date}
            videoId={videoId}
            metricsEnhanced={metricsEnhanced}
          />
        )}
      </CardContent>
    </Card>
  );
}
